import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from 'antd';
import "./style.scss";

const Solutions: React.FC = () => {
  function goToDefai() {
    window.open('https://defai.bscs.finance/')
  }

  function goToApply() {
    window.open('https://launchpad.bscs.finance/apply-to-launch')
  }

  function goToLp() {
    window.open('https://launchpad.bscs.finance/')
  }

  return (
    <div className="solutions-layout" id="solutions">
      <div className="layout">
        <div className="inner-layout">
          <div className="solution">
            <h4 className="title">OUR solutions</h4>
            <h2 className="name">Solutions for Everyone</h2>
            <Row className="solution-row">
              <Col style={{ cursor: 'pointer' }} className="left" xs={24} sm={24} lg={8} onClick={goToDefai}>
                <img className="top-left square" alt='' src='/images/footer/square.svg' />
                <img className="top-right square" alt='' src='/images/footer/square.svg' />
                <img className="bottom-left square" alt='' src='/images/footer/square.svg' />
                <img className="bottom-right square" alt='' src='/images/footer/square.svg' />
                <div className="flex solution-title">
                  <img alt='' src="/images/home/solutions/1.svg" />
                  <div className="text">
                    <p>1.1 /</p>
                    <h3>For Users</h3>
                  </div>
                </div>
                <p className="desc">Access high-yield DeFi and AI tools easily.</p>
                <div className="learn flex">
                  <p>Learn more</p>
                  <img alt='' src="/images/home/solutions/arrow.svg" />
                </div>
              </Col>
              <Col style={{ cursor: 'pointer' }} className="center" xs={24} sm={24} lg={8} onClick={goToApply}>
                <div className="flex solution-title">
                  <img alt='' src="/images/home/solutions/2.svg" />
                  <div className="text">
                    <p>1.2 /</p>
                    <h3>For Projects</h3>
                  </div>
                </div>
                <p className="desc">Launch and grow with our ecosystem.</p>
                <div className="learn flex">
                  <p>Learn more</p>
                  <img alt='' src="/images/home/solutions/arrow.svg" />
                </div>
              </Col>
              <Col style={{ cursor: 'pointer' }} className="right" xs={24} sm={24} lg={8} onClick={goToLp}>
                <img className="top-left square" alt='' src='/images/footer/square.svg' />
                <img className="top-right square" alt='' src='/images/footer/square.svg' />
                <img className="bottom-left square hide" alt='' src='/images/footer/square.svg' />
                <img className="bottom-right square hide" alt='' src='/images/footer/square.svg' />
                <div className="flex solution-title">
                  <img alt='' src="/images/home/solutions/3.svg" />
                  <div className="text">
                    <p>1.3 /</p>
                    <h3>For Investors</h3>
                  </div>
                </div>
                <p className="desc">Invest smarter with curated opportunities.</p>
                <div className="learn flex">
                  <p>Learn more</p>
                  <img alt='' src="/images/home/solutions/arrow.svg" />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
